import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import type { TroubleShootingState } from '@store/troubleshooting/types';
import type { ErrorMessagePayload } from '@store/types';

export const initialState: TroubleShootingState = {
  meta: {
    errorMessage: '',
    status: STATUS.SUCCESS,
  },
};

const handleRequest = (state: TroubleShootingState) => {
  state.meta.errorMessage = '';
  state.meta.status = STATUS.LOADING;
};

const handleSuccess = (state: TroubleShootingState) => {
  state.meta.status = STATUS.SUCCESS;
};

const handleFailure = (state: TroubleShootingState, action: PayloadAction<ErrorMessagePayload>) => {
  state.meta.status = STATUS.ERROR;
  state.meta.errorMessage = action.payload.errorMessage;
};

const troubleshooting = createSlice({
  name: 'troubleshooting',
  initialState,
  reducers: {
    reset: () => initialState,
    editRequest: handleRequest,
    editSuccess: handleSuccess,
    editFailure: handleFailure,
    deleteRequest: handleRequest,
    deleteSuccess: handleSuccess,
    deleteFailure: handleFailure,
    ignoreRequest: handleRequest,
    ignoreSuccess: handleSuccess,
    ignoreFailure: handleFailure,
  },
});

export const {
  reset: troubleshootingReset,
  editRequest: troubleshootingEditRequest,
  editSuccess: troubleshootingEditSuccess,
  editFailure: troubleshootingEditFailure,
  deleteRequest: troubleshootingDeleteRequest,
  deleteSuccess: troubleshootingDeleteSuccess,
  deleteFailure: troubleshootingDeleteFailure,
  ignoreRequest: troubleshootingIgnoreRequest,
  ignoreSuccess: troubleshootingIgnoreSuccess,
  ignoreFailure: troubleshootingIgnoreFailure,
} = troubleshooting.actions;

export default troubleshooting.reducer;
